<template>
  <div>
    <div>
      Sort by
      <DropdownMenu
        :outtericon="true"
        v-model="currentSortBy"
        :options="sortOptions"
        :textValue="'value'"
        :textLabel="'label'"
        @change="handleChangeSortBy"
      >
        <span style="font-weight: bold">{{ sortByLabel }}</span>
      </DropdownMenu>
    </div>
    <div>
      Order by
      <DropdownMenu
        :outtericon="true"
        v-model="currentOrderBy"
        :options="orderByOptions"
        :textValue="'value'"
        :textLabel="'label'"
        @change="handleChangeOrderBy"
      >
        <span style="font-weight: bold">{{ orderByLabel }}</span>
      </DropdownMenu>
    </div>
  </div>
</template>

<script>
import DropdownMenu from './DropdownMenu.vue'
export default {
  props: ['sortBy', 'options', 'orderBy'],
  data() {
    return {
      currentSortBy: this.sortBy,
      sortOptions: this.options,
      currentOrderBy: this.orderBy,
      orderByOptions: [
        {
          label: 'ASC',
          value: 'asc'
        },
        {
          label: 'DESC',
          value: 'desc'
        }
      ]
    }
  },
  components: {
    DropdownMenu
  },
  computed: {
    sortByLabel() {
      return this.sortOptions.find((el) => el.value == this.currentSortBy).label
    },
    orderByLabel() {
      return this.orderByOptions.find((el) => el.value == this.currentOrderBy).label
    }
  },
  methods: {
    handleChangeSortBy(value) {
      this.currentSortBy = value
      this.$emit('changeSort')
    },
    handleChangeOrderBy(value) {
      this.currentOrderBy = value
      this.$emit('changeSort')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Sortable.vue